export const EBILLING_TERMS = [
  {
    label:
      "The Tax Payment System PajakInd is supported by PT Bank Rakyat Indonesia as the PJAP based on KEP-315/PJ/2020.",
  },
  {
    label:
      "If incorrect E-Billing data is entered, and NTPN and BPN have already been issued, the user is not entitled to a refund.",
  },
  {
    label:
      "Users are entitled to a refund if the payment fails due to data error and the funds are not deposited to the state.",
  },
  {
    label:
      "Refunds are processed on the working day following the submission of the refund request to PajakInd.",
  },
  {
    label:
      "Refunds do not include the administrative fees that have been charged.",
  },
  {
    label:
      "The E-Billing payment status will not be updated if the payment is made outside of the PajakInd application.",
  },
  {
    label:
      "A proof of E-Billing payment will not be generated if the payment is made outside of the PajakInd application.",
  },
];
